import { Box } from '@mui/material';
import React from 'react';

interface EmailPreviewContentProps {
  sanitizedEmailHTML: string;
  iframeRef: React.RefObject<HTMLIFrameElement>;
  isModal?: boolean;
  onIframeLoad: (isModal: boolean) => void;
}

const EmailPreviewContent: React.FC<EmailPreviewContentProps> = ({
  sanitizedEmailHTML,
  iframeRef,
  isModal = false,
  onIframeLoad,
}) => (
  <Box
    sx={{
      width: '100%',
      height: isModal ? '100%' : '400px',
      position: 'relative',
      backgroundColor: '#ffffff',
      p: 2,
      overflow: 'auto',
    }}
  >
    <iframe
      ref={iframeRef}
      srcDoc={sanitizedEmailHTML}
      style={{
        width: '100%',
        height: '100%',
        minHeight: isModal ? '600px' : '400px',
        border: 'none',
        display: 'block',
        backgroundColor: '#ffffff',
      }}
      title="Email Preview"
      sandbox="allow-same-origin"
      scrolling="auto"
      onLoad={() => onIframeLoad(isModal)}
    />
  </Box>
);

export default EmailPreviewContent;
